import type { Serialised } from '@squaredup/ids';
import { VariableFormData } from 'pages/dashboard/components/utils/getVariableFromFormData';
import API from './API';
import { handleError, handleResponse } from './util';

type VariableDefault = 'all' | 'none';

export type VariableAndScope = {
    variable: {
        id: string;
        displayName: string;
        data: {
            default: VariableDefault;
            allowMultipleSelection: boolean;
            dashId: string;
        };
    };
    scope: { id: string };
};

export const ListVariables = (workspaceId: string) =>
    API.get<Serialised<VariableAndScope[]>>(`/workspaces/${workspaceId}/variables`)
        .then(handleResponse)
        .catch(handleError);

export const ListVariablesForDashboard = (dashboardId: string) =>
    API.get(`/dashboards/${dashboardId}/variables`).then(handleResponse).catch(handleError);

export const ListVariableObjects = (params: Record<string, unknown>) =>
    API.post('/variables/objects', params).then(handleResponse).catch(handleError);

export const GetVariableObjects = (params: { nodeIds: string[] }) =>
    API.get('/variables/objects/ids', { params }).then(handleResponse).catch(handleError);

export const AddVariable = (workspaceId: string, data: VariableFormData & { dashboardId: string }) =>
    API.post(`/workspaces/${workspaceId}/variables`, data)
        .then(handleResponse)
        .catch((error) => handleError(error));

export const UpdateVariable = (variableId: string, data: VariableFormData & { dashboardId: string }) =>
    API.put(`/variables/${variableId}`, data)
        .then(handleResponse)
        .catch((error) => handleError(error));

export const DeleteVariable = (variableId: string) =>
    API.delete(`/variables/${variableId}`)
        .then(handleResponse)
        .catch((error) => handleError(error));
